import { createSortOption } from "@nosto/preact"
export const sizes = [48, 96, 144]

export const sortOptions = [
    createSortOption("score", "Most relevant", { field: "score", order: "desc" }),
    createSortOption("-price", "Price descending", { field: "price", order: "desc" }),
    createSortOption("price", "Price ascending", { field: "price", order: "asc" })
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteProductsSize: 6,
    autocompleteKeywordsSize: 3,
    historySize: 5
}

export const SHOPIFY_STOREFRONT_ACCESS_TOKEN = 'e035c0e2e5113aea4413f4ab98f09ce8';
export const SHOPIFY_STORE_URL = 'https://petite-plume.myshopify.com/api/2024-01/graphql.json';